import React from 'react';
import {CACHE_KEY_DETAIL_DTM, CACHE_KEY_SOUBORY_DTM} from '../../queryKeys';
import {useQuery} from 'react-query';
import {DtmPrenosSouborVO, DtmPrenosVO, MapioDtmApi} from '../../api';
import {WaitForQueryData} from '@mc/react-app-v4';
import {Block, Card, Icon, LabelValue, List, ListItem, Space, Tag, Title} from '@mc/ui-v4';
import {formatDate} from '@mc/react-format';
import {getEnumTypVysledekDtmCaption} from '../../enums/EnumTypVysledekDtm';
import {mcFile} from '@mc/react-ui-icons';
import {getPrenosSouborUrl} from '../../utils/urlRedirectUtils';
import {getEnumStavPrenosDtmCaption} from '../../enums/EnumStavPrenosDtm';

type Props = {id: number};
export const DtmHomeDetail: React.FC<Props> = ({id}) => {
    const detailDtmQuery = useQuery<DtmPrenosVO>([CACHE_KEY_DETAIL_DTM, id], async () => (await MapioDtmApi.getPrenosDtm(id)).data, {
        enabled: !!id,
    });
    const souboryDtmQuery = useQuery<DtmPrenosSouborVO[]>([CACHE_KEY_SOUBORY_DTM, id], async () => (await MapioDtmApi.getPrenosSouborByIdPrenos(id)).data, {
        enabled: !!id,
    });

    return (
        <WaitForQueryData queries={[detailDtmQuery, souboryDtmQuery]}>
            {() => {
                const detailDtmData = detailDtmQuery.data;
                const souboryDtmData = souboryDtmQuery.data ?? [];
                return (
                    <Space vertical>
                        <Card mode={'view'} title={'Základní informace'}>
                            <Block>
                                <div className={'d-flex justify-content-between'}>
                                    <LabelValue label={'Datum'}>{formatDate(detailDtmData?.datum)}</LabelValue>
                                    <LabelValue label={'Id požadavku'}>{detailDtmData?.idPozadavku}</LabelValue>
                                    <LabelValue label={'Stav'}>{detailDtmData?.stav && getEnumStavPrenosDtmCaption(detailDtmData?.stav)}</LabelValue>
                                    <LabelValue label={'Výsledek'}>
                                        {detailDtmData?.vysledek && getEnumTypVysledekDtmCaption(detailDtmData?.vysledek)}
                                    </LabelValue>
                                    <LabelValue label={'Chyba'}>{detailDtmData?.chyba}</LabelValue>
                                </div>
                            </Block>
                        </Card>
                        <Card mode={'view'} title={'Soubory'}>
                            <List>
                                {souboryDtmData.map(item => (
                                    <ListItem key={item.idDtmPrenosSoubor} onClick={() => window.open(getPrenosSouborUrl(item.idDtmPrenosSoubor), '_blank')}>
                                        <Title type={'listItem'} icon={<Icon icon={mcFile} fixedWidth />} extra={<Tag>{item.typ}</Tag>}>
                                            {item.nazev}
                                        </Title>
                                    </ListItem>
                                ))}
                            </List>
                        </Card>
                    </Space>
                );
            }}
        </WaitForQueryData>
    );
};
